import React from "react";
import { Paper } from "@mui/material";

import OverzichtConsortiums from "../../components/consortiums/OverzichtConsortiums";

const PageConsortiums: React.FC = () => {
  return (
    <>
      <header className="app-header">
        <h1>Samenwerkingsverbanden beheren</h1>
        <p className="header-sub-title center">
          In onderstaand overzicht worden alle samenwerkingsverbanden getoond die zijn toegevoegd aan infraplannen.nl.
        </p>
      </header>

      <div className="content text-left">
        <Paper sx={{ width: "100%" }}>
          <div className="header">
            <h4>Overzicht van samenwerkingsverbanden</h4>
            <p>Samenwerkingsverbanden die gebruikt worden binnen infraplannen.nl.</p>

            <OverzichtConsortiums />
          </div>
        </Paper>
      </div>
    </>
  );
};

export default PageConsortiums;
